import React, { FC } from 'react';

import { isEmpty } from 'lodash-es';
import { useIntl } from 'react-intl';

import { selectors, useAppSelector } from 'state/global-state';

import { StyledIncentiveEvaluationMessage, StyledIncentiveEvaluationMessages } from '../styled';

interface ICartErrorMessagesProps {
  isOfferNotAvailable: boolean;
  isCartTotalNegative: boolean;
}

export const CartErrorMessages: FC<ICartErrorMessagesProps> = ({
  isOfferNotAvailable,
  isCartTotalNegative,
}) => {
  const { formatMessage } = useIntl();
  const offersFeedbackMap = useAppSelector(selectors.loyalty.selectOfferFeedbackMap);

  const showOffersFeedback = !isCartTotalNegative && !isEmpty(offersFeedbackMap);

  return (
    <>
      {isOfferNotAvailable && (
        <StyledIncentiveEvaluationMessage
          data-testid="offerNotAvailableInRestaurantPosErrorMsg"
          message={formatMessage({ id: 'offerNotAvailableInRestaurantPos' })}
        />
      )}
      {showOffersFeedback &&
        Object.keys(offersFeedbackMap).map(key => (
          <StyledIncentiveEvaluationMessages
            key={key}
            incentiveEvaluationResults={offersFeedbackMap[key]}
          />
        ))}
      {isCartTotalNegative && (
        <StyledIncentiveEvaluationMessage message={formatMessage({ id: 'negativeCartError' })} />
      )}
    </>
  );
};
